import React from "react";
import { imageCodes, titleCodes, textCodes } from '../../template_codes/ydnm/home_page_codes';

function Home() {
    return (
        <div>
            {/*           banner             */}
            <div className="w-full bg-cover pt-10 "
                style={{ backgroundImage: `url(${imageCodes.bannerBg.image})` }}
            >
                <div className="text-center py-40">
                    <h1 className="text-6xl text-center font-bold pb-8 text-[#f9f00c]">{titleCodes.bannerTitle.title}</h1>
                    <p className="text-center text-lg font-semibold text-[#e6e6e6]">{textCodes.bannerText1.text}</p>
                    <p className="text-center text-lg font-semibold text-[#e6e6e6] pb-20">{textCodes.bannerText2.text}</p>

                    <p className="btn px-16 rounded-full tracking-wider bg-[#03c7ff] text-[#ffffff] hover:tracking-widest ...">JOIN YDNM</p>
                </div>
            </div>
            {/*           end banner           */}

            {/*        platform logo       */}

            <div className="w-full bg-cover pt-10 "
                style={{ backgroundImage: `url(${imageCodes.blackBg.image})` }}
            >

                <div className="container w-4/5 pt-32">
                    <h1 className="text-5xl text-center font-bold pb-8 text-[#f9f00c]">{titleCodes.platformTitle.title}</h1>
                    <p className="text-center text-lg font-semibold px-10">{textCodes.platformText.text}</p>
                </div>

                <div className="container w-3/5 py-16">
                    <div className="grid grid-cols-3 md:grid-cols-3 lg:gird-cols-5 xl:grid-cols-5 2xl:grid-cols-5">
                        <div>
                            <img src={imageCodes.spotify.image} width={120} height={80}></img>
                        </div>
                        <div>
                            <img src={imageCodes.apple.image} width={120} height={80}></img>
                        </div>
                        <div>
                            <img src={imageCodes.amazon.image} width={160}></img>
                        </div>
                        <div>
                            <img src={imageCodes.youtube.image} width={120} height={80}></img>
                        </div>
                        <div>
                            <img src={imageCodes.tiktok.image} width={120} height={80}></img>
                        </div>
                    </div>
                </div>
            </div>
            {/*        end of platform logo       */}

            {/*        why choose       */}
            <div className="container w-4/5 pt-32">
                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2">
                    <div className="pl-20">
                        <img src={imageCodes.whyChoose.image}></img>
                    </div>
                    <div>
                        <h1 className="font-bold text-5xl text-[#f9f00c] pb-8">{titleCodes.chooseTitle.title}</h1>

                        <h1 className="font-bold text-2xl text-[#ffffff] pb-4">{titleCodes.chooseTitle1.title}</h1>
                        <p className="pb-10">{textCodes.chooseText1.text}</p>

                        <h1 className="font-bold text-2xl text-[#ffffff] pb-4">{titleCodes.chooseTitle2.title}</h1>
                        <p className="pb-10">{textCodes.chooseText2.text}</p>

                        <h1 className="font-bold text-2xl text-[#ffffff] pb-4">{titleCodes.chooseTitle3.title}</h1>
                        <p className="pb-10">{textCodes.chooseText3.text}</p>

                        <p className="btn px-16 rounded-full bg-[#03c7ff] text-[#ffffff] hover:tracking-widest ...">JOIN YDNM</p>
                    </div>
                </div>
            </div>
            {/*        end of why choose       */}

            {/*         how to sell        */}
            <div className="container w-4/5 py-20">
                <h1 className="text-5xl text-center font-bold pb-8 text-[#f9f00c]">{titleCodes.howtoSell.title}</h1>
                <p className="text-center text-lg font-semibold text-[#e6e6e6]">{textCodes.sellText.text}</p>
            </div>
            {/*         end of how to sell        */}


            {/*       artist community           */}
            <div className="w-full bg-cover py-20 "
                style={{ backgroundImage: `url(${imageCodes.blackBg.image})` }}
            >
                <div className="container w-5/6 py-10">
                    <h1 className="text-5xl text-center font-bold pb-16 text-[#f9f00c]">{titleCodes.artist.title}</h1>

                    <div className="carousel rounded-box">
                        <div className="carousel-item px-2">
                            <div className="card w-80">
                                <figure><img src={imageCodes.artist1.image} alt="Artist" /></figure>
                                <div className="justify-end w-full bg-cover"
                                    style={{ backgroundImage: `url(${imageCodes.blueBg.image})` }}>
                                    <p className="p-2 font-semibold text-black justify-end">Artist Name</p>
                                    <p className="text-black justify-end p-2">YDNM Artist</p>
                                </div>
                            </div>
                        </div>
                        <div className="carousel-item px-2">
                            <div className="card w-80">
                                <figure><img src={imageCodes.artist2.image} alt="Artist" /></figure>
                                <div className="justify-end w-full bg-cover"
                                    style={{ backgroundImage: `url(${imageCodes.blueBg.image})` }}>
                                    <p className="p-2 font-semibold text-black justify-end">Artist Name</p>
                                    <p className="text-black justify-end p-2">YDNM Artist</p>
                                </div>
                            </div>
                        </div>
                        <div className="carousel-item px-2">
                            <div className="card w-80">
                                <figure><img src={imageCodes.artist1.image} alt="Artist" /></figure>
                                <div className="justify-end w-full bg-cover"
                                    style={{ backgroundImage: `url(${imageCodes.blueBg.image})` }}>
                                    <p className="p-2 font-semibold text-black justify-end">Artist Name</p>
                                    <p className="text-black justify-end p-2">YDNM Artist</p>
                                </div>
                            </div>
                        </div>
                        <div className="carousel-item px-2">
                            <div className="card w-80">
                                <figure><img src={imageCodes.artist2.image} alt="Artist" /></figure>
                                <div className="justify-end w-full bg-cover"
                                    style={{ backgroundImage: `url(${imageCodes.blueBg.image})` }}>
                                    <p className="p-2 font-semibold text-black justify-end">Artist Name</p>
                                    <p className="text-black justify-end p-2">YDNM Artist</p>
                                </div>
                            </div>
                        </div>
                        <div className="carousel-item px-2">
                            <div className="card w-80">
                                <figure><img src={imageCodes.artist1.image} alt="Artist" /></figure>
                                <div className="justify-end w-full bg-cover"
                                    style={{ backgroundImage: `url(${imageCodes.blueBg.image})` }}>
                                    <p className="p-2 font-semibold text-black justify-end">Artist Name</p>
                                    <p className="text-black justify-end p-2">YDNM Artist</p>
                                </div>
                            </div>
                        </div>
                        <div className="carousel-item px-2">
                            <div className="card w-80">
                                <figure><img src={imageCodes.artist2.image} alt="Artist" /></figure>
                                <div className="justify-end w-full bg-cover"
                                    style={{ backgroundImage: `url(${imageCodes.blueBg.image})` }}>
                                    <p className="p-2 font-semibold text-black justify-end">Artist Name</p>
                                    <p className="text-black justify-end p-2">YDNM Artist</p>
                                </div>
                            </div>
                        </div>
                        <div className="carousel-item px-2">
                            <div className="card w-80">
                                <figure><img src={imageCodes.artist1.image} alt="Artist" /></figure>
                                <div className="justify-end w-full bg-cover"
                                    style={{ backgroundImage: `url(${imageCodes.blueBg.image})` }}>
                                    <p className="p-2 font-semibold text-black justify-end">Artist Name</p>
                                    <p className="text-black justify-end p-2">YDNM Artist</p>
                                </div>
                            </div>
                        </div>
                        <div className="carousel-item px-2">
                            <div className="card w-80">
                                <figure><img src={imageCodes.artist2.image} alt="Artist" /></figure>
                                <div className="justify-end w-full bg-cover"
                                    style={{ backgroundImage: `url(${imageCodes.blueBg.image})` }}>
                                    <p className="p-2 font-semibold text-black justify-end">Artist Name</p>
                                    <p className="text-black justify-end p-2">YDNM Artist</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            {/*       end of artist community           */}

            {/*         grow your career             */}
            <div className="container w-4/5 py-20">
                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2">
                    <div>
                        <img src={imageCodes.grow.image}></img>
                    </div>
                    <div className="pl-10">
                        <h1 className="font-bold text-5xl text-[#f9f00c] pb-8">{titleCodes.growTitle.title}</h1>

                        <h1 className="font-bold text-2xl text-[#ffffff] pb-4">{titleCodes.growTitle2.title}</h1>
                        <p className="text-lg font-semibold text-[#e6e6e6] pb-10">{textCodes.growText1.text}</p>
                        <p className="text-lg font-semibold text-[#e6e6e6] pb-10">{textCodes.growText2.text}</p>

                        <p className="btn px-16 rounded-full bg-[#03c7ff] text-[#ffffff] hover:tracking-widest ...">LEARN MORE</p>
                    </div>
                </div>
            </div>
            {/*         end of grow your career             */}

            {/*         grow your career             */}
            <div className="container w-4/5 py-10">
                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2">
                    <div className="pl-10">
                        <h1 className="font-bold text-5xl text-[#f9f00c] pb-4">{titleCodes.yourOwn.title}</h1>

                        <h1 className="font-bold text-5xl text-[#03c7ff] pb-8">{titleCodes.gDesigner.title}</h1>
                        <p className="text-lg font-semibold text-[#e6e6e6] pb-10">{textCodes.ownText.text}</p>
                        <p className="text-lg font-semibold text-[#e6e6e6] pb-10">{textCodes.ownText2.text}</p>

                        <p className="btn px-16 rounded-full bg-[#03c7ff] text-[#ffffff] hover:tracking-widest ...">LEARN MORE</p>
                    </div>
                    <div>
                        <img src="https://www.tunecore.com/wp-content/uploads/sites/12/2021/07/Tool.gif"></img>
                    </div>
                </div>
            </div>
            {/*         end of grow your career             */}


            {/*         grow your career             */}
            <div className="w-full bg-cover py-20 "
                style={{ backgroundImage: `url(${imageCodes.blackBg.image})` }}
            >
                <div className="container w-4/5 pt-10">
                    <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2">
                        <div>
                            <img src={imageCodes.mpublish.image}></img>
                        </div>
                        <div className="pl-10">
                            <h1 className="font-bold text-5xl text-[#f9f00c] pb-8">{titleCodes.mPublishing.title}</h1>

                            <p className="text-xl font-semibold text-[#e6e6e6] pb-10">{textCodes.publishText.text}</p>
                            <p className="text-lg font-semibold text-[#e6e6e6] pb-10">{textCodes.publishList1.text}</p>
                            <p className="text-lg font-semibold text-[#e6e6e6] pb-10">{textCodes.publishList2.text}</p>

                            <p className="btn px-16 rounded-full bg-[#03c7ff] text-[#ffffff] hover:tracking-widest ...">LEARN MORE</p>
                        </div>
                    </div>
                </div>
            </div>
            {/*         end of grow your career             */}
        </div >
    );
}

export default Home;